/* Slick Slider */

jQuery(document).ready(function($){
  $('.c-slick-slider').slick({
	  autoplay: true,
	  autoplaySpeed: 4000,
	  speed: 2000,
	  pauseOnHover: false,
	  arrows: false,
	  dots: false,
	  fade: true,
	  responsive: [
	  	{
		breakpoint: 768,
			settings: {
			fade: false,
			arrows: false,
			dots: false,
			speed: 500
			}
		}
		// You can unslick at a given breakpoint now by adding:
		// settings: "unslick"
		// instead of a settings object
	  ]
  });
});
